
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import Tournament from './tournament-creation.js';
export default {
  data: () => ({
    newTournamentData: null,
    navigationSheet: null,
    backBtn: null,
    konvert: null,
    doublePickMatch: false,
    backActiveBtn: true,
    counterStartedAt: null,
    dataTabs: {
      tab1: {
        days: [],
        leagues: []
      },
      tab2: {},
      tab3: {},
      tab4: {}
    },
    payload: {
      matches: [],
      title: '',
      ingress: 100,
      prizeType: 'winner'
    },
    tournamentInfo: null
  }),
  methods: {
    sharePinCode(pincode) {
      let self = this;
      if (self.$app.methods.getTypeApp() == 'olimp') {
        let shareData = { text: `ПИН ${ pincode }\nСобери команду и сыграй против меня в FanBattle Fantasy:\nhttps://fantasysports.app.link/go` };
        if (navigator.share) {
          navigator.share(shareData);
        }
        setTimeout(() => {
          self.sheetShareFriendsGame.close();
        }, 300);
      } else {
        this.$app.preloader.show();
        self.$app.methods.generateDinamicLinkForFriendTournament(pincode).then(function (data) {
          self.$app.preloader.hide();
          let shareData = { text: `Собери команду и сыграй против меня тут: ${ data.shortLink }` };
          if (navigator.share) {
            navigator.share(shareData);
          }
          setTimeout(() => {
            self.sheetShareFriendsGame.close();
          }, 300);
        });
      }
    },
    HANDLE_TAB_1() {
      const self = this;
      self.setActiveTab(0);
      self.$app.tab.show('#friendly-tab-1', true);
      self.$app.preloader.show();
      self.dataTabs.tab1.days = self.newTournamentData.get7Days();
      self.$setState({
        backActiveBtn: true,
        dataTabs: self.dataTabs
      });
      if (self.dataTabs.tab1.leagues.length > 0) {
        self.$app.preloader.hide();
        return false;
      }
      self.fetchAvailableMatches().then(dates => {
        if (dates.length > 0) {
          self.dataTabs.tab1.leagues = self.prepareLeagues(dates[0].leagues);
        }
        self.$setState({ dataTabs: self.dataTabs });
      }).catch(() => {
        self.$app.dialog.alert('Что-то пошло не так, попробуйте позже', '', () => {
          self.closePage();
        });
      });
    },
    HANDLE_TAB_2() {
      this.setActiveTab(1);
      this.$el.find('.title-block input')[0].value = this.payload.title;
      this.$setState({ payload: this.payload });
      this.$app.tab.show('#friendly-tab-2', true);
    },
    HANDLE_TAB_3() {
      this.setActiveTab(2);
      const w = window.innerWidth;
      let length = 41;
      if (w <= 426 && w >= 376) {
      } else if (w < 376 && w >= 321) {
        length = 33;
      } else {
        length = 24;
      }
      if (this.payload.title.length > length) {
        this.payload.h_title = this.payload.title.slice(0, length).concat('...');
      } else {
        this.payload.h_title = this.payload.title;
      }
      var minMatch = this.payload.matches.reduce(function (a, b) {
        return new Date(a.started_at) < new Date(b.started_at) ? a : b;
      });
      this.payload.startedAt = minMatch.shortDate;
      switch (this.payload.prizeType) {
      case 'winner':
        this.payload.prizText = 'Победитель забирает';
        break;
      case 'top3':
        this.payload.prizText = 'Трое лидеров забирают';
        break;
      default:
        break;
      }
      this.$setState({ payload: this.payload });
      this.$app.tab.show('#friendly-tab-3', true);
    },
    HANDLE_TAB_4() {
      this.setActiveTab(3);
      this.$setState({ backActiveBtn: false });
      this.payload.h_title = this.payload.title;
      const w = window.innerWidth;
      let length = 85;
      if (w <= 426 && w >= 376) {
      } else if (w < 376 && w >= 321) {
        length = 73;
      } else {
        length = 58;
      }
      if (this.payload.h_title.length > length) {
        this.payload.h_title = this.payload.title.slice(0, length).concat('...');
      }
      this.navigationSheet.querySelector('.button').textContent = 'Закрыть';
      this.$app.tab.show('#friendly-tab-4', true);
    },
    HANDLER_ACTIVE_TAB() {
      const self = this;
      self.tabs.forEach(el => {
      });
    },
    pickDay(day) {
      const self = this;
      self.$app.preloader.show();
      const activeTabInfo = self.getActiveTabInfo();
      const daysElements = self.$el.find(`#${ activeTabInfo.tab }`)[0].querySelector('.calendar').querySelectorAll('.day');
      daysElements.forEach(el => {
        if (el.classList.contains('active')) {
          el.classList.remove('active');
        }
      });
      const isDay = self.dataTabs.tab1.days.find(el => el.day == day);
      daysElements[isDay.count - 1].classList.add('active');
      self.dataTabs.tab1.days.map(element => {
        if (element.day == day) {
          element.isActive = true;
        } else {
          element.isActive = false;
        }
      });
      self.$setState({ dataTabs: self.dataTabs });
      self.fetchAvailableMatches().then(dates => {
        if (dates.length > 0) {
          self.dataTabs.tab1.leagues = self.prepareLeagues(dates[0].leagues);
        } else {
          self.dataTabs.tab1.leagues = [];
        }
        self.$setState({
          dataTabs: self.dataTabs,
          payload: self.setPayload(),
          doublePickMatch: false
        });
      }).catch(() => {
        self.$app.dialog.alert('Что-то пошло не так, попробуйте позже', '', () => {
          self.closePage();
        });
      });
    },
    focusPayloadIngress(e) {
      this.$el.find('#ingress')[0].type = 'number';
      this.$el.find('#ingress')[0].setAttribute('pattern', '[0-9]+');
      e.target.value = parseInt(this.payload.ingress);
    },
    blurPayloadIngress(e) {
      this.$el.find('#ingress')[0].type = 'text';
      this.$el.find('#ingress')[0].removeAttribute('pattern');
      if (this.$app.methods.getTypeApp() === 'olimp') {
        if (this.$root.params.profile.use_native_currency === true) {
          e.target.value = parseInt(this.payload.ingress) + ` ${ this.$root.params.profile.currency.sign }`;
        } else {
          e.target.value = parseInt(this.payload.ingress) + ' $';
        }
      } else {
        e.target.value = parseInt(this.payload.ingress) + '';
      }
    },
    inputPayloadIngress(e) {
      console.log(e.target.value);
    },
    updateKonvert(amount) {
      if (this.$app.methods.getTypeApp() === 'olimp') {
        if (this.$root.params.profile.use_native_currency === true) {
          this.$setState({
            konvert: {
              value: parseFloat(amount / this.$root.params.profile.currency.rate).toFixed(2),
              currency: '$'
            }
          });
        } else {
          this.$setState({
            konvert: {
              value: parseFloat(amount * this.$root.params.profile.currency.rate).toFixed(2),
              currency: this.$root.params.profile.currency.sign
            }
          });
        }
      } else {
        this.$setState({
          konvert: {
            value: parseFloat(amount).toFixed(2),
            currency: ''
          }
        });
      }
    },
    setPayload() {
      let payload = {
        ingress: 0,
        matches: [],
        prizeType: 'winner',
        title: ''
      };
      if (this.$app.methods.getTypeApp() === 'olimp') {
        if (this.$root.params.profile.use_native_currency === false) {
          payload.ingress = 1 + ' $';
        } else {
          payload.ingress = 100 + ` ${ this.$root.params.profile.currency.sign }`;
        }
      } else {
        payload.ingress = 1 + '';
      }
      this.updateKonvert(parseInt(payload.ingress));
      return payload;
    },
    fetchAvailableMatches() {
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.getShortActiveDay();
        self.$root.api(`/app/personal/matches`, { date }, 'GET', function (response, status, xhr) {
          if (status == 200) {
            resolve(response.dates);
          }
          reject();
        }, true);
      });
    },
    pickMatch(id) {
      const self = this;
      const activeTabInfo = self.getActiveTabInfo();
      let matchElementHTML = self.$el.find(`#${ activeTabInfo.tab }`)[0].querySelector(`#match-${ id }`);
      const matchesElement = self.$el.find('.matches')[0].querySelectorAll('.match');
      const inputElement = matchElementHTML.querySelector('input[type="checkbox"]');
      if (!self.doublePickMatch) {
        self.doublePickMatch = true;
        if (inputElement.getAttribute('checked')) {
          inputElement.removeAttribute('checked');
          const matchID = +inputElement.getAttribute('value');
          const idx = self.payload.matches.findIndex(el => el.id == matchID);
          self.payload.matches = [
            ...self.payload.matches.slice(0, idx),
            ...self.payload.matches.slice(idx + 1, self.payload.matches.length)
          ];
          self.$setState({ payload: self.payload });
        } else {
          inputElement.setAttribute('checked', true);
          const matchID = +inputElement.getAttribute('value');
          let match = null;
          self.dataTabs.tab1.leagues.map(league => {
            league.matches.map(el => {
              if (el.id == matchID) {
                match = el;
              }
            });
          });
          self.payload.matches.push(match);
          self.$setState({ payload: self.payload });
        }
        setTimeout(() => {
          self.$setState({ doublePickMatch: false });
        }, 0);
      }
    },
    minus() {
      let ingress = 100;
      if (this.$root.params.profile.use_native_currency === false) {
        ingress = 1;
      }
      if (parseInt(this.payload.ingress) > ingress) {
        this.payload.ingress = parseInt(this.payload.ingress) - ingress;
        if (this.$app.methods.getTypeApp() === 'olimp') {
          if (this.$root.params.profile.use_native_currency === true) {
            this.payload.ingress = parseInt(this.payload.ingress) + ` ${ this.$root.params.profile.currency.sign }`;
          } else {
            this.payload.ingress = parseInt(this.payload.ingress) + ' $';
          }
        } else {
          this.payload.ingress = parseInt(this.payload.ingress) + '';
        }
        this.$setState({ payload: this.payload });
        this.updateKonvert(parseInt(this.payload.ingress));
      }
    },
    plus() {
      let ingress = 100;
      if (this.$root.params.profile.use_native_currency === false) {
        ingress = 1;
      }
      this.payload.ingress = parseInt(this.payload.ingress) + ingress;
      if (this.$app.methods.getTypeApp() === 'olimp') {
        if (this.$root.params.profile.use_native_currency === true) {
          this.payload.ingress = parseInt(this.payload.ingress) + ` ${ this.$root.params.profile.currency.sign }`;
        } else {
          this.payload.ingress = parseInt(this.payload.ingress) + ' $';
        }
      } else {
        this.payload.ingress = parseInt(this.payload.ingress) + '';
      }
      this.$setState({ payload: this.payload });
      this.updateKonvert(parseInt(this.payload.ingress));
    },
    updatePayloadIngress(e) {
      let ingress = +e.target.value;
      this.payload.ingress = ingress;
      if (this.payload.ingress === 0) {
        if (this.$root.params.profile.use_native_currency === true) {
          this.payload.ingress = 100;
        } else {
          this.payload.ingress = 1;
        }
      }
      this.$setState({ payload: this.payload });
    },
    updatePayloadTitle(e) {
      let title = e.target.value;
      this.payload.title = title;
      this.$setState({ payload: this.payload });
    },
    changeWinner(e) {
      const items = this.$el[0].querySelectorAll('.winner-select .item');
      items.forEach(el => {
        el.classList.remove('active');
      });
      const item = e.target.closest('.item');
      item.classList.add('active');
      this.payload.prizeType = item.getAttribute('data-value');
      this.$setState({ payload: this.payload });
    },
    preventEvent(e) {
      e.preventDefault();
    },
    getShortActiveDay() {
      const activeDay = this.getActiveDay();
      let day = activeDay.date.getDate();
      if (day < 10) {
        day = `0${ day }`;
      }
      let month = activeDay.date.getMonth() + 1;
      if (month < 10) {
        month = `0${ month }`;
      }
      let year = activeDay.date.getFullYear();
      return `${ day }.${ month }.${ year }`;
    },
    getActiveDay() {
      return this.dataTabs.tab1.days.find(el => el.isActive === true);
    },
    next() {
      const self = this;
      const activeTabInfo = this.getActiveTabInfo();
      switch (activeTabInfo.tab) {
      case 'friendly-tab-1':
        if (self.payload.matches.length == 0) {
          this.$app.dialog.alert('Выберите хотя бы один матч', '');
          return false;
        }
        self.HANDLE_TAB_2();
        break;
      case 'friendly-tab-2':
        if (self.payload.title.length == 0) {
          this.$app.dialog.alert('Введите название турнира', '');
          return false;
        }
        if (self.payload.title.length <= 3) {
          this.$app.dialog.alert('Название турнира слишком короткое', '');
          return false;
        }
        if (self.payload.title.length > 33) {
          this.$app.dialog.alert('Название турнира слишком длинное', '');
          return false;
        }
        self.HANDLE_TAB_3();
        break;
      case 'friendly-tab-3':
        self.createTournament().then(tournament => {
          tournament.creator = self.$root.params.profile;
          try {
            tournament.tournament.h_call_for_before = self.getTime(tournament.tournament.call_for_before);
          } catch (e) {
            console.log(e);
          }
          console.log(tournament.tournament.call_for_before);
          self.counterStartedAt = setInterval(() => {
            tournament.tournament.h_call_for_before = self.getTime(tournament.tournament.call_for_before);
            self.$setState({ tournamentInfo: tournament });
          }, 1000);
          self.$setState({ tournamentInfo: tournament });
          self.HANDLE_TAB_4();
        }).catch(data => {
          self.$app.dialog.alert(data.message, '');
          self.closePage();
        });
        break;
      case 'friendly-tab-4':
        try {
          self.$root.events.emit('lobby.loadTournaments');
          self.closePage();
        } catch (e) {
          console.error(e);
          self.closePage();
        }
        break;
      default:
        break;
      }
    },
    getTime(call_for_before) {
      var timeStarted = new Date(call_for_before);
      var timeCurrent = new Date();
      var distance = timeStarted.getTime() - timeCurrent.getTime();
      if (distance <= 0)
        return;
      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(distance % (1000 * 60) / 1000);
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      return hours + ':' + minutes + ':' + seconds;
    },
    createTournament() {
      const self = this;
      self.$app.preloader.show();
      return new Promise((resolve, reject) => {
        let matches = self.payload.matches.map(match => {
          return match.id;
        });
        let ingress;
        if (this.$root.params.profile.use_native_currency === true) {
          ingress = parseInt(self.payload.ingress) / parseFloat(this.$root.params.profile.currency.rate).toFixed(2);
        } else {
          ingress = parseInt(self.payload.ingress);
        }
        let params = {
          'title': '' + self.payload.title,
          'ingress': parseFloat(ingress).toFixed(2),
          'prize_type': self.payload.prizeType,
          'matches_ids': matches
        };
        self.$root.api(`/app/personal/tournament/create`, { ...params }, 'POST', function (data, status, xhr) {
          self.$app.preloader.hide();
          if (data.status == 'error') {
            reject(data);
          }
          resolve(data);
        }, true);
      });
    },
    setActiveTab(number) {
      this.stepperList.querySelectorAll('li').forEach(element => {
        if (element.classList.contains('active')) {
          element.classList.remove('active');
        }
      });
      this.stepperList.querySelectorAll('li')[number].classList.add('active');
    },
    handlerBackbtn() {
      const self = this;
      self.backBtn = self.$app.navbar.getElByPage(self.$el).querySelector('.left .link');
      self.backBtn.addEventListener('click', e => {
        e.preventDefault();
        const activeTabInfo = this.getActiveTabInfo();
        switch (activeTabInfo.tab) {
        case 'friendly-tab-1':
          self.closePage();
          break;
        case 'friendly-tab-2':
          self.HANDLE_TAB_1();
          break;
        case 'friendly-tab-3':
          self.HANDLE_TAB_2();
          break;
        case 'friendly-tab-4':
          self.HANDLE_TAB_3();
          break;
        default:
          break;
        }
      });
    },
    prepareLeagues(data) {
      const leagues = [];
      data.map(league => {
        let matches = [];
        league.matches.map(match => {
          let date = new Date(match.started_at);
          let day = date.getDate();
          if (day < 10) {
            day = '0' + day;
          }
          let month = date.getMonth() + 1;
          if (month < 10) {
            month = '0' + month;
          }
          let year = date.getFullYear();
          year = String(year).slice(-2);
          let hours = date.getHours();
          if (hours < 10) {
            hours = '0' + hours;
          }
          let minutes = date.getMinutes();
          if (minutes < 10) {
            minutes = '0' + minutes;
          }
          match.shortDate = `${ day }.${ month }.${ year } ${ hours }:${ minutes }`;
          matches.push(match);
        });
        leagues.matches = matches;
        leagues.push(league);
      });
      return leagues;
    },
    getActiveTabInfo() {
      let activeTab = null;
      this.tabs.forEach(el => {
        if (el.classList.contains('tab-active')) {
          activeTab = el;
        }
      });
      return {
        html: activeTab,
        tab: activeTab.getAttribute('id')
      };
    },
    closePage() {
      this.$router.back();
      if (this.navigationSheet)
        this.$app.sheet.close(this.navigationSheet);
      document.querySelector('.toolbar').style.display = 'block';
    }
  },
  on: {
    pageInit: function () {
      this.$setState({ payload: this.setPayload() });
      this.stepperList = this.$app.navbar.getElByPage(this.$el).querySelector('.stepper-list');
      this.navigationSheet = this.$el.find('.navigation-sheet')[0];
      this.tabs = this.$el.find('.friends-tournament-tabs')[0].querySelector('.tabs').querySelectorAll('.page-content');
      this.handlerBackbtn();
      this.newTournamentData = Tournament.init();
      this.HANDLE_TAB_1();
      this.$app.sheet.open(this.navigationSheet);
    },
    pageBeforeRemove: function () {
      clearInterval(this.counterStartedAt);
      this.$setState({
        counterStartedAt: null,
        dataTabs: {
          tab1: {
            days: [],
            leagues: []
          },
          tab2: {},
          tab3: {},
          tab4: {}
        },
        doublePickMatch: false,
        payload: {
          ingress: 100,
          matches: [],
          prizeType: 'winner',
          title: ''
        }
      });
    }
  },
  id: '7dd3ffc787',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page friends-tournament-creation-page" data-name="friends-tournament">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner">\n                <div class="left">\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.backActiveBtn, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <a href="#" class="link icon-only">\n                        <i class="icon icon-back"></i>\n                    </a>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n                <div class="title">\n                    <ul class="stepper-list">\n                        <li class="active"><span>1</span></li>\n                        <li><span>2</span></li>\n                        <li><span>3</span></li>\n                        <li><span><i class="icon icon-flag-svg"></i></span></li>\n                        <div class="line"></div>\n                    </ul>\n                </div>\n                <div class="right">\n                    <!-- <a href="#" class="link icon-only">\n                      <i class="icon-info-svg"></i>\n                    </a> -->\n                </div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="tabs-animated-wrap friends-tournament-tabs">\n                <div class="tabs">\n                    <!-- ТАБ 1 -->\n                    <div id="friendly-tab-1" class="page-content tab tab-active pt-0">\n                        ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.dataTabs, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tab1, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="calendar">\n                            ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.days, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                            <div\n                                class="day ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.toDay == true', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'today';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ' ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.isActive == true', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'active';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '"\n                                @click="pickDay(\'';
                  r += c(ctx_4.day, ctx_4);
                  r += '\')">\n                                <div class="content">\n                                    <span>';
                  r += c(ctx_4.text, ctx_4);
                  r += '</span>\n                                    <span>';
                  r += c(ctx_4.day, ctx_4);
                  r += '</span>\n                                </div>\n                            </div>\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                        </div>\n                        <div class="matches">\n                            <div class="title">Выберите матч</div>\n                            <div class="list list-matches accordion-list accordion-opposite">\n                                <ul class="leagues">\n                                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.leagues, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                    <li class="accordion-item"><a class="item-content item-link" href="#">\n                                        <div class="item-inner">\n                                            <div class="item-title">';
                  r += c(ctx_4.name, ctx_4);
                  r += '</div>\n                                        </div>\n                                    </a>\n                                        <div class="accordion-item-content">\n                                            <ul class="matches">\n                                                ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.matches, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                <li id="match-';
                      r += c(ctx_5.id, ctx_5);
                      r += '" class="match" @click="pickMatch(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\')">\n                                                    <div class="match-row">\n                                                        <label class="checkbox item-checkbox" @click="preventEvent">\n                                                            <input type="checkbox" name="match" value="';
                      r += c(ctx_5.id, ctx_5);
                      r += '">\n                                                            <i class="icon-checkbox"></i>\n                                                        </label>\n                                                        <div class="match-block">\n                                                            <span class="match-title">';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.is_virtual, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<span>*</span>';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += c(ctx_5.localteam, ctx_5);
                      r += ' - ';
                      r += c(ctx_5.visitorteam, ctx_5);
                      r += '</span>\n                                                            <span class="match-data">';
                      r += c(ctx_5.shortDate, ctx_5);
                      r += '</span>\n                                                        </div>\n                                                    </div>\n                                                </li>\n                                                ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                            </ul>\n                                        </div>\n                                    </li>\n                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                </ul>\n                            </div>\n                        </div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                    <!-- ТАБ 2 -->\n                    <div id="friendly-tab-2" class="page-content tab pt-0">\n                        <div class="ingress-block">\n                            <h4>Какой единовременный взнос?</h4>\n                            <div class="stepper">\n                                <div class="minus" @click="minus">\n                                    <i class="icon icon-minus-svg"></i>\n                                </div>\n                                <div class="amount">\n                                    ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.payload, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                    <input id="ingress" type="text" class="ingress" name="ingress"\n                                           value="';
          r += c(ctx_2.ingress, ctx_2);
          r += '" @input="inputPayloadIngress" @focus="focusPayloadIngress" @blur="blurPayloadIngress" @change="updatePayloadIngress">\n                                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                    <span class="hint">Сумма взноса</span>\n                                </div>\n                                <div class="plus" @click="plus">\n                                    <i class="icon icon-plus-svg"></i>\n                                </div>\n                            </div>\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.konvert, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                <div class="konvert"><span>Стоимость входа будет</span><span>';
          r += c(ctx_2.konvert.value, ctx_2);
          r += c(ctx_2.konvert.currency, ctx_2);
          r += '</span></div>\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </div>\n                        <div class="prize-type-block">\n                            <h4>Кто забирает главный приз?</h4>\n                            <div class="winner-select">\n                                <div class="item active" data-value="winner" @click="changeWinner">\n                                    <span>Победитель</span>\n                                </div>\n                                <div class="item" data-value="top3" @click="changeWinner">\n                                    <span>Топ 3</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="title-block">\n                            <h4>Название турнира</h4>\n                            <input type="text" name="title" placeholder="Суперлига в воскресенье"\n                                   @change="updatePayloadTitle">\n                        </div>\n                    </div>\n                    <!-- ТАБ 3 -->\n                    <div id="friendly-tab-3" class="page-content tab pt-0">\n                        <div class="header-block">\n                            <h4>Почти закончили!</h4>\n                            <span class="subtitle">Подтвердите ваши настройки</span>\n                        </div>\n                        <div class="result-block">\n                            <div class="banner"></div>\n                            <div class="content">\n                                <div class="item">\n                                    <div class="icon-block">\n                                        <i class="icon icon-friends-tournament-clock"></i>\n                                    </div>\n                                    <div class="description">\n                                        ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.payload, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                        <span class="text">';
          r += c(ctx_2.h_title, ctx_2);
          r += '</span>\n                                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                        <span class="hint">Название турнира</span>\n                                    </div>\n                                </div>\n                                <div class="item">\n                                    <div class="icon-block">\n                                        <i class="icon icon-friends-tournament-clock"></i>\n                                    </div>\n                                    <div class="description">\n                                        ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.payload, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                        <span class="text">';
          r += c(ctx_2.startedAt, ctx_2);
          r += '</span>\n                                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                        <span class="hint">Начало состязания</span>\n                                    </div>\n                                </div>\n                                <div class="item">\n                                    <div class="icon-block">\n                                        <i class="icon icon-friends-tournament-ingress"></i>\n                                    </div>\n                                    <div class="description">\n                                        ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.payload, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                        <span class="text">';
          r += c(ctx_2.ingress, ctx_2);
          r += '</span>\n                                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                        <span class="hint">Взнос\n                                          ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.$app.methods.getTypeApp() === \'origin\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                            <i class="fas fa-star"></i>\n                                          ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.$root.params.profile.use_native_currency == false', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                            ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.$root.params.profile.use_native_currency == false', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                                $\n                                            ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                                ';
              r += c(ctx_3.$root.params.profile.currency.sign, ctx_3);
              r += '\n                                            ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                        </span>\n                                    </div>\n                                </div>\n                                <div class="item">\n                                    <div class="icon-block">\n                                        <i class="icon icon-friends-tournament-prize"></i>\n                                    </div>\n                                    <div class="description">\n                                        ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.payload, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                        <span class="text">';
          r += c(ctx_2.prizText, ctx_2);
          r += '</span>\n                                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                        <span class="hint">Главный приз</span>\n                                    </div>\n                                </div>\n                                <div class="items">\n                                    ';
      r += Template7Helpers.with.call(ctx_1, ctx_1.payload, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.matches, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <div class="item">\n                                        <div class="icon-block">\n                                            <i class="icon icon-friends-tournament-match"></i>\n                                        </div>\n                                        <div class="description">\n                                            <span class="text">';
              r += c(ctx_3.localteam, ctx_3);
              r += ' - ';
              r += c(ctx_3.visitorteam, ctx_3);
              r += '</span>\n                                            <span class="hint">';
              r += c(ctx_3.shortDate, ctx_3);
              r += '</span>\n                                        </div>\n                                    </div>\n                                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <!-- ТАБ 4 -->\n                    <div id="friendly-tab-4" class="page-content tab pt-0">\n                        <div class="header-block">\n                            <h4>Турнир создан!</h4>\n                            <span class="subtitle">Вы успешно создали турнир</span>\n                        </div>\n                        <div class="tournament-label">\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.tournamentInfo, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tournamentInfo, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="header">\n                                <h4>';
              r += c(ctx_3.tournament.title, ctx_3);
              r += '</h4>\n                            </div>\n                            <div class="body">\n                                <div class="priz">\n                                    ';
              r += Template7Helpers.js_if.call(ctx_3, 'window.APP_FANBATTLE.methods.getTypeApp() === \'origin\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                    <span>';
                  r += c(ctx_4.tournament.prize.value, ctx_4);
                  r += '<i class="fas fa-star"></i></span>\n                                    ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <span>';
                  r += c(ctx_4.tournament.prize.value, ctx_4);
                  r += ' ';
                  r += c(ctx_4.tournament.prize.currency, ctx_4);
                  r += '</span>\n                                    ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                    <span>Приз</span>\n                                </div>\n                                <div class="ingress">\n                                    ';
              r += Template7Helpers.js_if.call(ctx_3, 'window.APP_FANBATTLE.methods.getTypeApp() === \'origin\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                    <span>';
                  r += c(ctx_4.tournament.ingress.value, ctx_4);
                  r += '<i class="fas fa-star"></i></span>\n                                    ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                    <span>';
                  r += c(ctx_4.tournament.ingress.value, ctx_4);
                  r += ' ';
                  r += c(ctx_4.tournament.ingress.currency, ctx_4);
                  r += '</span>\n                                    ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                    <span>Взнос</span>\n                                </div>\n                                <div class="start_at">\n                                    <span>';
              r += c(ctx_3.tournament.h_call_for_before, ctx_3);
              r += '</span>\n                                    <span>До начала</span>\n                                </div>\n                            </div>\n                            <div class="footer">\n                                <div class="creator">\n                                    <img src="';
              r += c(ctx_3.creator.avatar.url, ctx_3);
              r += '" alt="">\n                                    <div class="info">\n                                        <span>';
              r += c(ctx_3.creator.name, ctx_3);
              r += '</span>\n                                        <span>Создал</span>\n                                    </div>\n                                </div>\n                            </div>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </div>\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.tournamentInfo, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += Template7Helpers.with.call(ctx_2, ctx_2.tournamentInfo, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="header-block">\n                            <h4>Пригласите друзей!</h4>\n                            <span class="subtitle">Отправь пин-код друзьям</span>\n                        </div>\n                        <div class="pincode-block">\n                            <div class="pincode">\n                                <span>';
              r += c(ctx_3.tournament.pin, ctx_3);
              r += '</span>\n                                <span>ПИН-КОД</span>\n                            </div>\n                            <div class="btn">\n                                <button @click="sharePinCode(';
              r += c(ctx_3.tournament.pin, ctx_3);
              r += ')">\n                                    <span><i class="icon icon-shared"></i>Поделиться</span>\n                                </button>\n                            </div>\n                        </div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- Навигационное модальное окно -->\n        <div class="sheet-modal navigation-sheet">\n            <div class="sheet-modal-inner">\n                <div class="page-content">\n                    <div class="block">\n                        <button class="button success" @click="next">Дальше</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
    .friends-tournament-creation-page .page-content .tabs .calendar {
        height: 47px;
        display: flex;
        flex-direction: row;
    }

    .friends-tournament-creation-page .page-content .tabs .calendar .day {
        background-color: #E6E6E6;
        width: 100%;
        height: 45px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .friends-tournament-creation-page .page-content .tabs .calendar .day + .day {
        /*     border-left: 1px solid #E6E6E6;
            border-width: thin; */
    }

    .friends-tournament-creation-page .page-content .tabs .calendar .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        height: 100%;
        width: 100%;
        margin: 1px;
    }

    .friends-tournament-creation-page .page-content .tabs .calendar .day span:nth-child(1) {
        font-weight: 300;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.07px;
        text-transform: uppercase;
        color: #15367A;
    }

    .friends-tournament-creation-page .page-content .tabs .calendar .day span:nth-child(2) {
        font-weight: 300;
        font-size: 15px;
        line-height: 18px;
        letter-spacing: -0.24px;
        color: #15367A;
    }

    .friends-tournament-creation-page .page-content .tabs .calendar .day.today span {
        font-weight: bold;
    }

    .friends-tournament-creation-page .page-content .tabs .calendar .day.active::after {
        content: '';
        position: absolute;
        background-color: #007AFF;
        display: block;
        z-index: 15;
        top: auto;
        right: auto;
        bottom: 0;
        left: 0;
        height: 3px;
        width: 100%;
        transform-origin: 50% 100%;
        transform: scaleY(calc(1 / 1));
        transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    }

    .friends-tournament-creation-page .page-content .tabs .calendar .day.active .content {
        background-color: #F3F3F3;
    }

    .friends-tournament-creation-page .matches {
        overflow: auto;
    }

    .friends-tournament-creation-page .matches .title {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        letter-spacing: -0.08px;
        text-transform: uppercase;
        color: rgba(0, 0, 0, 0.4);
        padding-top: 24px;
        margin: 0px 16px 8px;
    }

    .friends-tournament-creation-page .matches .list .accordion-item .item-content:after {
        content: '';
        position: absolute;
        background-color: var(--f7-list-border-color);
        display: block;
        z-index: 15;
        top: auto;
        right: auto;
        bottom: 0;
        left: 0;
        height: 1px;
        width: 100%;
        transform-origin: 50% 100%;
        transform: scaleY(calc(1 / 1));
        transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    }

    .friends-tournament-creation-page .matches .accordion-list li:after {
        content: '';
        position: absolute;
        background-color: var(--f7-list-border-color);
        display: block;
        z-index: 15;
        top: auto;
        right: auto;
        bottom: 0;
        left: 0;
        height: 1px;
        width: 100%;
        transform-origin: 50% 100%;
        transform: scaleY(calc(1 / 1));
        transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    }

    .friends-tournament-creation-page .matches .list .accordion-item .item-content .item-title {
        color: #000000;
    }

    .friends-tournament-creation-page .matches .accordion-list li .match-row {
        align-items: center;
        display: flex;
        height: 60px;
        margin-left: 16px;
    }

    .friends-tournament-creation-page .matches .accordion-list li .match-row .match-title {
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        line-height: 17px;
        letter-spacing: -0.41px;
        color: #000000;
    }

    .friends-tournament-creation-page .matches .accordion-list li .match-row .match-title + .match-data {
        margin-top: 4px;
    }
    .friends-tournament-creation-page .konvert {
        max-width: 282px;
        margin: 4px auto 0px;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 14px;
        letter-spacing: 0.07px;
        color: #818E95;
        display: flex;
        justify-content: space-between;
    }

    .friends-tournament-creation-page .matches .accordion-list li .match-row .match-data {
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 15px;
        letter-spacing: -0.24px;
        color: #8C8C8C;
    }

    .friends-tournament-creation-page .matches .accordion-list li .match-row .checkbox {
        margin-right: 16px;
    }

    .friends-tournament-creation-page .matches .accordion-list li .match-row .item-checkbox i {
        position: unset;
        top: unset;
        margin-top: unset;
        right: unset;
        margin: 0px;
    }

    .friends-tournament-creation-page .matches .accordion-list li .match-row .match-block {
        display: flex;
        flex-direction: column;
    }

    .friends-tournament-creation-page .ingress-block {
        margin: 40px 16px 0px;
    }

    .friends-tournament-creation-page h4 {
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.41px;
        color: #445058;
        text-align: center;
        margin: 0px;
    }

    .friends-tournament-creation-page .ingress-block h4 + .stepper {
        margin-top: 16px;
    }

    .friends-tournament-creation-page .ingress-block .stepper {
        background-color: #ffffff;
        height: 56px;
        border-radius: 8px;
        display: flex;
        border: 1px solid #CFD6DB;
        max-width: 282px;
        margin: 0 auto;
    }

    .friends-tournament-creation-page .ingress-block .stepper .minus {
        width: 25%;
        height: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #CFD6DB;
    }

    .friends-tournament-creation-page .ingress-block .stepper .amount {
        width: 50%;
        height: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .friends-tournament-creation-page .ingress-block .stepper .amount .ingress {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 20px;
        letter-spacing: 0.38px;
        color: #445058;
        width: inherit;
        text-align: center;
    }

    .friends-tournament-creation-page .ingress-block .stepper .plus {
        width: 25%;
        height: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #CFD6DB;
    }

    .friends-tournament-creation-page .ingress-block .stepper .amount .ingress + .hint {
        margin-top: 2px;
    }

    .friends-tournament-creation-page .ingress-block .stepper .amount .hint {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 10px;
        letter-spacing: 0.07px;
        text-transform: uppercase;
        color: #818E95;
    }

    .friends-tournament-creation-page .prize-type-block {
        margin: 32px 16px 0px;
    }

    .friends-tournament-creation-page .prize-type-block .winner-select {
        max-width: 282px;
        height: 56px;
        margin: 0 auto;
        display: flex;
        background: #FFFFFF;
        border-radius: 7px;
    }

    .friends-tournament-creation-page .prize-type-block .winner-select .item {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        background: #FFFFFF;
        color: #007AFF;
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
        letter-spacing: -0.08px;
    }

    .friends-tournament-creation-page .prize-type-block .winner-select .item.active {
        background: #007AFF;
        color: #FFFFFF;
    }

    .friends-tournament-creation-page .prize-type-block .winner-select .item:nth-child(1) {
        border-top-left-radius: 7px;
        border-bottom-left-radius: 7px;
    }

    .friends-tournament-creation-page .prize-type-block .winner-select .item:nth-child(1).active {
        border-top-right-radius: 7px;
        border-bottom-right-radius: 7px;
    }

    .friends-tournament-creation-page .prize-type-block .winner-select .item:nth-child(2) {
        border-top-right-radius: 7px;
        border-bottom-right-radius: 7px;
    }

    .friends-tournament-creation-page .prize-type-block .winner-select .item:nth-child(2).active {
        border-top-left-radius: 7px;
        border-bottom-left-radius: 7px;
    }

    .friends-tournament-creation-page .prize-type-block h4 + .winner-select {
        margin-top: 16px;
    }

    .friends-tournament-creation-page .title-block {
        margin: 32px 0px 0px;
    }

    .friends-tournament-creation-page .title-block h4 + input {
        margin-top: 16px;
    }

    .friends-tournament-creation-page .title-block input {
        height: 56px;
        background: #FFFFFF;
        width: 100%;
        padding-left: 24px;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 18px;
        letter-spacing: -0.24px;
        color: #000000;
    }

    .friends-tournament-creation-page .header-block {
        margin: 40px 16px 16px;
        text-align: center;
    }

    .friends-tournament-creation-page .header-block h4 {
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.41px;
        color: #445058;
    }

    .friends-tournament-creation-page .header-block .subtitle {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: -0.08px;
        color: #818E95;
    }

    .friends-tournament-creation-page .header-block h4 + .subtitle {
        margin-top: 4px;
    }

    .friends-tournament-creation-page .result-block {
        border-radius: 8px;
        margin: 16px;
        border: 1px solid #CFD6DB;
        border-width: thin;
        background-color: #FFFFFF;
    }

    .friends-tournament-creation-page .result-block .banner {
        background-image: url("data:image/svg+xml,%3Csvg width='341' height='68' viewBox='0 0 341 68' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='341' height='68'%3E%3Cpath d='M0 7C0 3.13401 3.13401 0 7 0H334C337.866 0 341 3.13401 341 7V68H0V7Z' fill='%23C4C4C4'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Cpath d='M343.953 -136.559H-15.4878V224.99H343.953V-136.559Z' fill='%2385CC40'/%3E%3Cpath d='M7.42653 -136.559H-15.4878V224.99H7.42653V-136.559Z' fill='%237FC435'/%3E%3Cpath d='M52.3564 -136.558H29.4421V224.991H52.3564V-136.558Z' fill='%237FC435'/%3E%3Cpath d='M97.2865 -136.558H74.3722V224.99H97.2865V-136.558Z' fill='%237FC435'/%3E%3Cpath d='M142.216 -136.558H119.302V224.991H142.216V-136.558Z' fill='%237FC435'/%3E%3Cpath d='M187.147 -136.558H164.232V224.99H187.147V-136.558Z' fill='%237FC435'/%3E%3Cpath d='M232.077 -136.558H209.162V224.991H232.077V-136.558Z' fill='%237FC435'/%3E%3Cpath d='M277.007 -136.558H254.092V224.991H277.007V-136.558Z' fill='%237FC435'/%3E%3Cpath d='M321.936 -136.557H299.022V224.991H321.936V-136.557Z' fill='%237FC435'/%3E%3Cg opacity='0.4'%3E%3Cg opacity='0.3'%3E%3Crect x='71.4238' y='-35.4698' width='86.4814' height='86.8802' fill='url(%23pattern0)'/%3E%3C/g%3E%3Cg opacity='0.3'%3E%3Crect x='177.746' y='-32.2158' width='82.923' height='83.5178' fill='url(%23pattern1)'/%3E%3C/g%3E%3Cpath opacity='0.3' d='M3.8501 6.09925C3.8501 21.7362 16.453 34.413 31.9988 34.413C47.5446 34.413 60.1475 21.7362 60.1475 6.09925C60.1475 -9.53774 47.5446 -22.2145 31.9988 -22.2145C16.453 -22.2145 3.8501 -9.53322 3.8501 6.09925Z' fill='white'/%3E%3Cg opacity='0.4'%3E%3Cpath opacity='0.3' d='M309.99 -37.8563C309.99 -16.4752 327.221 0.856583 348.477 0.856583C369.734 0.856583 386.964 -16.4752 386.964 -37.8563C386.964 -59.2373 369.734 -76.5691 348.477 -76.5691C327.221 -76.5646 309.99 -59.2328 309.99 -37.8563Z' fill='white'/%3E%3Cg opacity='0.3'%3E%3Crect x='337.338' y='12.9054' width='84.6483' height='85.0363' fill='url(%23pattern2)'/%3E%3C/g%3E%3Cg opacity='0.3'%3E%3Crect x='-43.0939' y='-72.8901' width='80.0115' height='80.4808' fill='url(%23pattern3)'/%3E%3C/g%3E%3Cpath opacity='0.3' d='M-49.9671 93.6618C-49.9671 113.294 -34.1472 129.207 -14.6296 129.207C4.88807 129.207 20.708 113.294 20.708 93.6618C20.708 74.0297 4.88807 58.1171 -14.6296 58.1171C-34.1472 58.1171 -49.9671 74.0297 -49.9671 93.6618Z' fill='white'/%3E%3C/g%3E%3C/g%3E%3Cg opacity='0.3'%3E%3Cpath opacity='0.3' d='M165.589 -136.558H162.875V224.99H165.589V-136.558Z' fill='%23F5F7F2'/%3E%3Cg opacity='0.3'%3E%3Cg opacity='0.3'%3E%3Cpath opacity='0.3' d='M164.232 105.734C130.508 105.734 103.073 78.1383 103.073 44.216C103.073 10.2937 130.508 -17.3015 164.232 -17.3015C197.952 -17.3015 225.391 10.2937 225.391 44.216C225.387 78.1338 197.952 105.734 164.232 105.734ZM164.232 -14.5086C132.04 -14.5086 105.85 11.8348 105.85 44.216C105.85 76.5972 132.04 102.941 164.232 102.941C196.425 102.941 222.614 76.5972 222.614 44.216C222.614 11.8348 196.425 -14.5086 164.232 -14.5086Z' fill='%23F5F7F2'/%3E%3C/g%3E%3Cpath opacity='0.3' d='M169.74 44.2163C169.74 47.2804 167.274 49.7615 164.228 49.7615C161.186 49.7615 158.715 47.2804 158.715 44.2163C158.715 41.1567 161.181 38.671 164.228 38.671C167.274 38.671 169.74 41.1567 169.74 44.2163Z' fill='%23F5F7F2'/%3E%3C/g%3E%3Cg opacity='0.3'%3E%3Cg opacity='0.3'%3E%3Cpath opacity='0.3' d='M30.453 157.426H-15.488V155.166H28.2065V-66.7342H-15.488V-68.9938H30.453V157.426Z' fill='%23F5F7F2'/%3E%3C/g%3E%3Cg opacity='0.3'%3E%3Cpath opacity='0.3' d='M31.5357 89.0034C30.7315 89.0034 29.9093 88.9311 29.0915 88.7865L28.166 88.6193V-0.186164L29.0915 -0.353378C29.9093 -0.497998 30.727 -0.570312 31.5357 -0.570312C38.2079 -0.570312 44.4262 4.17954 49.045 12.8115C53.5425 21.2175 56.0226 32.3713 56.0226 44.2165C56.0226 56.0618 53.5425 67.2156 49.045 75.6216C44.4262 84.2536 38.2079 89.0034 31.5357 89.0034ZM30.4125 86.6895C30.7899 86.7256 31.1628 86.7437 31.5357 86.7437C43.7972 86.7437 53.7761 67.6675 53.7761 44.2165C53.7761 20.7656 43.7972 1.68937 31.5357 1.68937C31.1628 1.68937 30.7899 1.70744 30.4125 1.7436V86.6895Z' fill='%23F5F7F2'/%3E%3C/g%3E%3C/g%3E%3Cg opacity='0.3'%3E%3Cg opacity='0.3'%3E%3Cpath opacity='0.3' d='M298.012 157.426H343.953V155.167H300.258V-66.7339H343.953V-68.9935H298.012V157.426Z' fill='%23F5F7F2'/%3E%3C/g%3E%3Cg opacity='0.3'%3E%3Cpath opacity='0.3' d='M279.42 75.6216C274.922 67.2156 272.442 56.0619 272.442 44.2166C272.442 32.3714 274.918 21.2176 279.42 12.8116C284.038 4.18412 290.257 -0.570251 296.929 -0.570251C297.733 -0.570251 298.555 -0.497937 299.373 -0.353317L300.299 -0.186103V88.6193L299.373 88.7865C298.56 88.9312 297.738 89.0035 296.929 89.0035C290.257 89.0035 284.038 84.2536 279.42 75.6216ZM298.052 1.74366C297.675 1.7075 297.302 1.68943 296.929 1.68943C284.667 1.68943 274.689 20.7656 274.689 44.2166C274.689 67.6676 284.667 86.7438 296.929 86.7438C297.302 86.7438 297.675 86.7257 298.052 86.6895V1.74366Z' fill='%23F5F7F2'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3Cg filter='url(%23filter0_d)'%3E%3Crect x='-23.8601' y='-34.0001' width='103.274' height='103.88' fill='url(%23pattern4)'/%3E%3Cpath d='M67.4218 16.004C67.4218 36.972 50.5251 53.9717 29.6755 53.9717C8.8259 53.9717 -8.07085 36.972 -8.07085 16.004C-8.07085 -4.96401 8.82975 -21.9637 29.6755 -21.9637C50.5212 -21.9637 67.4218 -4.96788 67.4218 16.004Z' fill='%23F9F8F7'/%3E%3Cpath d='M63.5384 -0.77459C60.1398 -7.70069 54.7051 -13.4305 48.0195 -17.1781H44.875L48.0311 -7.92911L59.574 2.84525L63.5384 -0.77459Z' fill='%23222222'/%3E%3Cpath d='M8.2485 4.97434L19.087 -8.55652L35.2833 -3.41905L34.5328 14.1227L17.5937 19.384L8.2485 4.97434Z' fill='%23222222'/%3E%3Cpath d='M2.02107 36.3023L6.60512 46.043C10.9929 49.4577 16.1466 51.9238 21.766 53.1278L27.0583 45.0751L14.226 34.0491L2.02107 36.3023Z' fill='%23222222'/%3E%3Cpath d='M42.2577 40.1856L46.2451 24.2738L59.0736 18.3813L62.6877 30.2862L52.4727 42.9421L42.2577 40.1856Z' fill='%23222222'/%3E%3Cpath d='M26.8616 45.3731L27.0579 45.0711L26.8386 44.8814L42.3343 39.8833L42.2573 40.1853L42.6461 40.2898L26.8616 45.3731Z' fill='%23E5E0DC'/%3E%3Cpath d='M14.4451 34.2308L14.2296 34.045L13.9255 34.1031L17.4126 19.1088L17.5935 19.3836L17.9168 19.283L14.4451 34.2308Z' fill='%23E5E0DC'/%3E%3Cpath d='M46.2449 24.2734L34.2131 14.223L34.5326 14.1223L34.548 13.7855L46.7414 24.045L46.2449 24.2734Z' fill='%23E5E0DC'/%3E%3Cpath d='M2.27867 36.8519L-6.38525 23.0849L-5.95032 23.3946L-5.87334 23.0268L2.3518 36.2402L2.0208 36.3022L2.27867 36.8519Z' fill='%23E5E0DC'/%3E%3Cpath d='M-2.65172 8.28029L-2.59015 7.98218L-2.62092 7.73053L8.51785 4.63721L8.24842 4.97402L8.41007 5.22181L-2.65172 8.28029Z' fill='%23E5E0DC'/%3E%3Cpath d='M59.2927 19.0974L59.0733 18.3811L58.8231 18.4973L59.3235 2.61255L59.5736 2.84483L59.8277 2.61255L59.2927 19.0974Z' fill='%23E5E0DC'/%3E%3Cpath d='M62.445 30.5881L62.6875 30.2861L62.6105 30.0344L64.9275 29.6008L64.7351 30.0964L62.445 30.5881Z' fill='%23E5E0DC'/%3E%3Cpath d='M51.6988 46.8404L51.1407 47.2353L52.2299 42.876L52.4724 42.9418L52.8611 42.4579L51.6988 46.8404Z' fill='%23E5E0DC'/%3E%3Cpath opacity='0.2' d='M62.0717 1.12221C62.8377 14.4982 60.3821 34.2389 39.9443 43.8557C24.7026 51.0296 4.71902 45.5514 6.32017 38.8499C7.92132 32.1483 22.8282 37.1851 38.2046 23.7743C50.7598 12.8296 61.1595 -14.8748 62.0717 1.12221Z' fill='white'/%3E%3C/g%3E%3Crect opacity='0.3' x='-3.97667' y='-7' width='350.942' height='95' fill='%23273F10'/%3E%3C/g%3E%3Cdefs%3E%3Cpattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'%3E%3Cuse xlink:href='%23image0'/%3E%3C/pattern%3E%3Cpattern id='pattern1' patternContentUnits='objectBoundingBox' width='1' height='1'%3E%3Cuse xlink:href='%23image1'/%3E%3C/pattern%3E%3Cpattern id='pattern2' patternContentUnits='objectBoundingBox' width='1' height='1'%3E%3Cuse xlink:href='%23image2'/%3E%3C/pattern%3E%3Cpattern id='pattern3' patternContentUnits='objectBoundingBox' width='1' height='1'%3E%3Cuse xlink:href='%23image3'/%3E%3C/pattern%3E%3Cfilter id='filter0_d' x='-23.8601' y='-34.0001' width='106.274' height='110.88' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3E%3CfeOffset dx='3' dy='7'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3E%3C/filter%3E%3Cpattern id='pattern4' patternContentUnits='objectBoundingBox' width='1' height='1'%3E%3Cuse xlink:href='%23image4'/%3E%3C/pattern%3E%3Cimage id='image0' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyQAAAMkCAYAAABJCuQEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA'/%3E%3Cimage id='image1' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAwMAAAMHCAYAAABls4s1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA'/%3E%3Cimage id='image2' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAxQAAAMUCAYAAAAlg2GRAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA'/%3E%3Cimage id='image3' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAuoAAALqCAYAAABjZ3GmAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA'/%3E%3Cimage id='image4' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABGEAAARhCAYAAACCkJgyAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA'/%3E%3C/defs%3E%3C/svg%3E%0A");
        height: 82px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        background-repeat: no-repeat;
        width: 100%;
        background-size: cover;
    }

    .friends-tournament-creation-page .result-block .content {
        padding: 16px;
    }

    .friends-tournament-creation-page .result-block .item {
        height: 50px;
        width: inherit;
        display: flex;
        border: 1px solid #007AFF;
        border-width: thin;
        border-radius: 7px;
    }

    .friends-tournament-creation-page .result-block .item .icon-block {
        width: 50px;
        height: 50px;
        background: #007AFF;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
    }

    .icon-friends-tournament-clock {
        width: 24px;
        height: 24px;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.2123 8.10509C20.1572 5.6454 18.3644 3.85654 15.8842 2.79874C14.6446 2.27005 13.3458 2 11.989 2C10.6325 2 9.34335 2.2675 8.10509 2.79874C5.6454 3.85373 3.84464 5.64144 2.78775 8.10509C2.25815 9.33936 2 10.6325 2 11.989C2 13.3458 2.25815 14.6497 2.78775 15.8842C3.84464 18.3478 5.64563 20.1463 8.10509 21.2015C9.34358 21.7328 10.6325 22 11.989 22C13.3456 22 14.6446 21.73 15.884 21.2015C18.3642 20.1437 20.157 18.3437 21.2123 15.8842C21.7435 14.6457 22.011 13.3458 22.011 11.989C22.011 10.6325 21.7437 9.34354 21.2123 8.10509ZM19.615 16.4094C18.8296 17.7564 17.7536 18.825 16.3984 19.615C15.0514 20.4005 13.5755 20.7966 11.9893 20.7966C10.7968 20.7966 9.65891 20.5669 8.57564 20.0963C7.4924 19.626 6.55711 19.0077 5.77472 18.2255C4.99233 17.4432 4.3696 16.4987 3.90395 15.4136C3.43968 14.3325 3.21469 13.1818 3.21469 11.989C3.21469 10.4026 3.60448 8.93417 4.38549 7.59091C5.16929 6.24276 6.24553 5.17302 7.59114 4.38523C8.93652 3.59748 10.4028 3.20347 11.989 3.20347C13.5755 3.20347 15.0512 3.5998 16.3982 4.38523C17.7534 5.17534 18.8271 6.24504 19.6148 7.59088C20.4026 8.93649 20.7963 10.4026 20.7963 11.989C20.7963 13.5755 20.4051 15.0539 19.615 16.4094Z' fill='white'/%3E%3Cpath d='M12.6244 11.9018V6.23433C12.6244 5.89519 12.3289 5.62164 11.9898 5.62164C11.6726 5.62164 11.388 5.89519 11.388 6.23433V11.9893C11.388 12.0003 11.41 12.0442 11.41 12.0769C11.388 12.2738 11.4429 12.4379 11.5741 12.5693L14.8456 15.8406C15.0645 16.0595 15.4692 16.0595 15.688 15.8406C15.9395 15.589 15.923 15.2239 15.688 14.9872L12.6244 11.9018Z' fill='white'/%3E%3C/svg%3E%0A");
    }

    .icon-friends-tournament-match {
        width: 24px;
        height: 24px;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='3.5' y='6.5' width='17.5714' height='4.57143' rx='1.5' stroke='white'/%3E%3Crect x='3.5' y='13.9286' width='17.5714' height='4.57143' rx='1.5' stroke='white'/%3E%3C/svg%3E%0A");
    }

    .icon-friends-tournament-prize {
        width: 24px;
        height: 24px;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.3849 4.51567H18.69C18.6998 4.21718 18.7053 3.91693 18.7053 3.61524C18.7053 3.27542 18.4297 3 18.09 3H4.91013C4.57047 3 4.29489 3.27542 4.29489 3.61524C4.29489 3.91693 4.30034 4.21718 4.31011 4.51567H1.61524C1.27542 4.51567 1 4.79108 1 5.13091C1 7.88763 1.7205 10.4885 3.02869 12.4545C4.32181 14.3981 6.04432 15.5129 7.9051 15.6214C8.32695 16.0804 8.77284 16.4547 9.23731 16.7402V19.4746H8.20519C6.9574 19.4746 5.94242 20.4898 5.94242 21.7374V22.7695H5.89868C5.55886 22.7695 5.28344 23.0451 5.28344 23.3848C5.28344 23.7246 5.55886 24 5.89868 24H17.1015C17.4413 24 17.7167 23.7246 17.7167 23.3848C17.7167 23.0451 17.4413 22.7695 17.1015 22.7695H17.0577V21.7374C17.0577 20.4898 16.0428 19.4746 14.795 19.4746H13.7628V16.7402C14.2273 16.4548 14.6734 16.0804 15.0952 15.6214C16.9558 15.5129 18.6784 14.3981 19.9716 12.4545C21.2798 10.4885 22.0002 7.88763 22.0002 5.13091C22.0002 4.79108 21.7247 4.51567 21.3849 4.51567ZM4.05312 11.7729C2.97405 10.1514 2.34007 8.03038 2.24346 5.74615H4.37885C4.60075 8.55413 5.25989 11.1497 6.29009 13.2099C6.45416 13.5381 6.62575 13.8481 6.80376 14.14C5.78044 13.7535 4.83339 12.9457 4.05312 11.7729ZM15.8273 21.7374V22.7697H7.1729V21.7374C7.1729 21.1683 7.63593 20.7051 8.20519 20.7051H14.795C15.3642 20.7051 15.8273 21.1683 15.8273 21.7374ZM12.5324 19.4746H10.4678V17.2748C10.806 17.3639 11.1506 17.4102 11.5001 17.4102C11.8495 17.4102 12.1941 17.3639 12.5324 17.2748V19.4746ZM12.9134 15.8111C12.8856 15.8224 12.8591 15.8362 12.8336 15.8514C12.3987 16.0677 11.9519 16.1797 11.5001 16.1797C11.0484 16.1797 10.6017 16.0677 10.1671 15.8518C10.1413 15.8362 10.1145 15.8224 10.0865 15.8108C9.60405 15.5557 9.13734 15.1705 8.69594 14.6644C8.6727 14.6312 8.64659 14.6006 8.61759 14.5727C8.17939 14.0525 7.76715 13.4126 7.39064 12.6596C6.25997 10.3984 5.60692 7.42524 5.53258 4.23048H17.4676C17.3931 7.42524 16.74 10.3986 15.6095 12.6596C15.233 13.4126 14.8208 14.0525 14.3827 14.5727C14.3536 14.6006 14.3271 14.6314 14.3041 14.6645C13.8627 15.1708 13.3958 15.5558 12.9134 15.8111ZM18.947 11.7729C18.1668 12.9457 17.2197 13.7535 16.1964 14.14C16.3744 13.8481 16.546 13.5381 16.7101 13.2099C17.7403 11.1497 18.3993 8.55413 18.6213 5.74615H20.7567C20.6601 8.03038 20.0261 10.1514 18.947 11.7729Z' fill='white'/%3E%3C/svg%3E%0A");
    }

    .icon-friends-tournament-ingress {
        width: 24px;
        height: 24px;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.269 10.8133L10.1361 7.99987L9.00313 10.8133L5.89473 11.0029L8.29314 12.9368L7.51791 15.8676L10.1361 14.2419L12.7542 15.8676L11.979 12.9368L14.3774 11.0029L11.269 10.8133Z' fill='white'/%3E%3Cpath d='M16.3861 9.41079H15.4303V11.9408H16.3861V9.41079Z' fill='white'/%3E%3Cpath d='M16.3861 12.5592H15.4303V15.0892H16.3861V12.5592Z' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M22.9453 6H1.21552V6.21552H1V9.84183H1.47789C2.81097 9.84183 3.88606 10.9169 3.88606 12.25C3.88606 13.5831 2.81099 14.6582 1.47789 14.6582H1V18.5H22.9453V14.6582H22.4674C21.1343 14.6582 20.0592 13.5831 20.0592 12.25C20.0592 10.9169 21.1343 9.84183 22.4674 9.84183H22.9453V6ZM1.95577 8.95894V6.95577H15.4303V8.79235H16.3861V6.95577H21.9895V8.95894C20.3697 9.1945 19.1035 10.5579 19.1035 12.25C19.1035 13.9424 20.371 15.2973 21.9895 15.5328V17.5442H16.3861V15.7076H15.4303V17.5442H1.95577V15.5328C3.57426 15.2973 4.84183 13.9424 4.84183 12.25C4.84183 10.5579 3.57555 9.1945 1.95577 8.95894Z' fill='white'/%3E%3C/svg%3E%0A");
    }

    .friends-tournament-creation-page .result-block .item + .item {
        margin-top: 16px;
    }

    .friends-tournament-creation-page .result-block .item .description {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 8px 6px 8px 12px;
    }

    .friends-tournament-creation-page .result-block .item .description .text {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.24px;
        color: #445058;
    }

    .friends-tournament-creation-page .result-block .item .description .text + .hint {
        margin-top: 2px;
    }

    .friends-tournament-creation-page .result-block .item .description .hint {
        font-style: normal;
        font-weight: normal;
        font-size: 9px;
        line-height: 13px;
        letter-spacing: 0.07px;
        text-transform: uppercase;
        color: #007AFF;
        display: flex;
        align-items: center;
    }

    .friends-tournament-creation-page .result-block .item + .items {
        margin-top: 16px;
    }

    .friends-tournament-creation-page .result-block .items .item + .item {
        margin-top: 0px;
    }

    .friends-tournament-creation-page .result-block .items .item:not(:last-child) {
        border-bottom: 0px;
    }

    .friends-tournament-creation-page .result-block .items .item:not(:first-child) {
        border-top: 1px solid #CFD6DB;
        border-width: thin;
    }

    .friends-tournament-creation-page .result-block .items .item {
        border-radius: 0 !important;
    }

    .friends-tournament-creation-page .result-block .items .item .icon-block {
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }

    .friends-tournament-creation-page .result-block .items .item:first-child {
        border-top-left-radius: 7px !important;
        border-top-right-radius: 7px !important;
    }

    .friends-tournament-creation-page .result-block .items .item:last-child {
        border-bottom-left-radius: 7px !important;
        border-bottom-right-radius: 7px !important;
    }

    .friends-tournament-creation-page .result-block .items .item:first-child .icon-block {
        border-top-left-radius: 6px !important;
    }

    .friends-tournament-creation-page .result-block .items .item:last-child .icon-block {
        border-bottom-left-radius: 6px !important;
    }

    .friends-tournament-creation-page .tournament-label {
        margin-top: 16px;
        margin-bottom: 16px;
        margin-left: 16px;
        margin-right: 16px;
        border-radius: 9px;
        border: 1px solid #CFD6DB;
        height: 126px;
        background-color: #FFFFFF;
        padding: 12px 14px;
    }

    .friends-tournament-creation-page .tournament-label .header {
        height: 35px;
    }

    .friends-tournament-creation-page .tournament-label .header h4 {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 15.7px;
        letter-spacing: -0.24px;
        color: #007AFF;
        text-align: left;
    }

    .friends-tournament-creation-page .tournament-label .body {
        height: 35px;
        display: flex;
    }

    .friends-tournament-creation-page .tournament-label .body .priz {
        display: flex;
        flex: 1;
        flex-direction: column;
    }

    .friends-tournament-creation-page .tournament-label .body .priz span:nth-child(1) {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.24px;
        color: #445058;
        display: flex;
        align-items: center;
    }

    .friends-tournament-creation-page .tournament-label .body .priz span:nth-child(2) {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.07px;
        text-transform: uppercase;
        color: #818E95;
    }

    .friends-tournament-creation-page .tournament-label .body .priz span + span {
        margin-top: 2px;
    }

    .friends-tournament-creation-page .tournament-label .body .priz span:nth-child(1) .fa-star {
        font-style: normal;
        margin-left: 2px;
        font-size: calc(1em - 3px);
        display: block;
        height: 18px;
        line-height: 18px;
    }

    .friends-tournament-creation-page .tournament-label .body .ingress {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
    }

    .friends-tournament-creation-page .tournament-label .body .ingress span:nth-child(1) {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.24px;
        color: #445058;
        display: flex;
        align-items: center;
    }

    .friends-tournament-creation-page .tournament-label .body .ingress span:nth-child(1) .fa-star {
        font-style: normal;
        margin-left: 2px;
        font-size: calc(1em - 3px);
        display: block;
        height: 18px;
        line-height: 18px;
    }

    .friends-tournament-creation-page .tournament-label .body .ingress span:nth-child(2) {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.07px;
        text-transform: uppercase;
        color: #818E95;
    }

    .friends-tournament-creation-page .tournament-label .body .ingress span + span {
        margin-top: 2px;
    }

    .friends-tournament-creation-page .tournament-label .body .start_at {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: flex-end;
    }

    .friends-tournament-creation-page .tournament-label .body .start_at span:nth-child(1) {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.24px;
        color: #445058;
    }

    .friends-tournament-creation-page .tournament-label .body .start_at span:nth-child(2) {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.07px;
        text-transform: uppercase;
        color: #818E95;
    }

    .friends-tournament-creation-page .tournament-label .body .start_at span + span {
        margin-top: 2px;
    }

    .friends-tournament-creation-page .tournament-label .footer {
        height: 35px;
    }

    .friends-tournament-creation-page .tournament-label .footer .creator {
        display: flex;
    }

    .friends-tournament-creation-page .tournament-label .footer .creator img {
        border-radius: 50%;
        width: 35px;
        height: 35px;
        object-fit: cover;
        margin-right: 8px;
    }

    .friends-tournament-creation-page .tournament-label .footer .creator .info {
        display: flex;
        flex-direction: column;
    }

    .friends-tournament-creation-page .tournament-label .footer .creator .info span:nth-child(1) {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.24px;
        color: #445058;
    }

    .friends-tournament-creation-page .tournament-label .footer .creator .info span:nth-child(2) {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.07px;
        text-transform: uppercase;
        color: #818E95;
    }

    .friends-tournament-creation-page .tournament-label .header + .body {
        margin-top: 12px;
    }

    .friends-tournament-creation-page .tournament-label .body + .footer {
        margin-top: 8px;
    }

    .friends-tournament-creation-page .pincode-block {
        background-color: #FFFFFF;
        border: 1px solid #CFD6DB;
        justify-content: space-between;
        padding: 16px;
        display: flex;
    }

    .friends-tournament-creation-page .pincode-block .pincode {
        display: flex;
        flex-direction: column;
    }

    .friends-tournament-creation-page .pincode-block .pincode span:nth-child(1) {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: -0.41px;
        color: #445058;
    }

    .friends-tournament-creation-page .pincode-block .pincode span:nth-child(2) {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        letter-spacing: 0.07px;
        color: #818E95;
    }

    .friends-tournament-creation-page .pincode-block .pincode span + span {
        margin-top: 4px;
    }

    .friends-tournament-creation-page .pincode-block .btn {
        display: flex;
        align-items: center;
    }

    .friends-tournament-creation-page .pincode-block .btn button {
        background-color: #007AFF;
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        letter-spacing: -0.41px;
        color: #FFFFFF;
        border-radius: 6px;
        height: 40px;
        border: 0px;
        padding: 0px 16px;
    }

    .friends-tournament-creation-page .pincode-block .btn button i {
        margin-right: 8px;
        margin-top: -5px;
    }

    /* ТАБ-1 */
    .friends-tournament-creation-page .page-content .tabs > #friendly-tab-1.page-content {
        background-color: #EFEFF4;
    }

    /* ТАБ-2 */
    .friends-tournament-creation-page .page-content .tabs > #friendly-tab-2.page-content {
        background-color: #EFEFF4;
    }

    /* ТАБ-3 */
    .friends-tournament-creation-page .page-content .tabs > #friendly-tab-3.page-content {
        background-color: #EFEFF4;
    }

    /* ТАБ-4 */
    .friends-tournament-creation-page .page-content .tabs > #friendly-tab-4.page-content {
        background-color: #EFEFF4;
    }

    /* Навигационное модальное окно */
    .navigation-sheet {
        height: calc(79px + var(--f7-safe-area-bottom));
        box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.1);
    }

    .navigation-sheet .page-content {
        background-color: #ffffff;
    }

    .navigation-sheet .page-content .block {
        margin-top: 15.5px;
        margin-bottom: calc(15.5px + var(--f7-safe-area-bottom));
    }

    .navigation-sheet .page-content .block .button {
        height: 46px;
    }

    @media (max-width: 375px) {

    }

    @media (max-width: 320px) {

    }
`,
  styleScoped: false
};
    